import { useEffect } from 'react';
import { STORE_LINKS } from '../config';
import PhoneMockup from '../components/PhoneMockup';
import PromoVideo from '../components/PromoVideo';

const FEATURES = [
  { icon: 'fa-users', title: 'Group Chats', text: 'A shared space for your family, friends or team, where voice notes, photos and everyday plans all come together in one easy conversation.' },
  { icon: 'fa-face-smile', title: 'Fun Stickers & AR', text: 'Playful stickers, camera filters and face effects that respond in real time, adding a little personality to every moment you share.' },
  { icon: 'fa-circle-notch', title: 'Daily Stories', text: 'Little snapshots of your day, in photos or short videos, that stay up for 24 hours so friends can catch up on what you have been up to.' },
  { icon: 'fa-gamepad', title: 'Games With Friends', text: 'Challenge your friends to Crazy Eights right inside the app, or play solo games and climb the leaderboard. Friends you invite to a game join for free.' },
  { icon: 'fa-video', title: 'Voice & Video Calls', text: 'Clear voice and video calls for the moments when a message is not quite enough, whether you want to hear a familiar voice or see a smiling face.' },
  { icon: 'fa-shield-halved', title: 'Privacy First', text: 'Thoughtfully built so that your messages, photos and personal details stay yours, shared only with the people you choose.' },
];

function StoreButtons() {
  return (
    <>
      <a href={STORE_LINKS.ios} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
        <i className="fa-brands fa-apple"></i> App Store
      </a>
      <a href={STORE_LINKS.android} target="_blank" rel="noopener noreferrer" className="btn btn-secondary">
        <i className="fa-brands fa-google-play"></i> Google Play
      </a>
    </>
  );
}

export default function HomePage() {
  useEffect(() => {
    document.title = 'Yappyli: Chat Happily';
  }, []);

  return (
    <div className="yp">
      {/* HERO SECTION */}
      <section className="hero" id="hero">
        <div className="container hero-grid">
          <div className="hero-content">
            <span className="section-tag">Welcome to Yappyli</span>
            <h1>Chat Happily with the ones you love.</h1>
            <p>
              The messaging app designed for humans, not data points. Stay close effortlessly with fast group
              chats, games to play together, fun stickers, stories, and sleek dark mode.
            </p>
            <div className="hero-buttons">
              <StoreButtons />
            </div>
          </div>

          {/* HERO ARTIFICIAL MOCKUP */}
          <div className="hero-mockup-wrapper">
            <PhoneMockup theme="light" />
          </div>
        </div>
      </section>

      {/* FEATURES SECTION */}
      <section className="features" id="features">
        <div className="container">
          <div className="text-center">
            <span className="section-tag">Why Yappyli?</span>
            <h2 className="section-title">Designed for real human connection</h2>
            <p className="section-desc">Fast, secure, and intuitive features designed to keep you seamlessly connected.</p>
          </div>

          <div className="features-grid">
            {FEATURES.map((f) => (
              <div className="feature-card" key={f.title}>
                <div className="feature-icon"><i className={`fa-solid ${f.icon}`}></i></div>
                <h3>{f.title}</h3>
                <p>{f.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PROMO VIDEO */}
      <section className="theme-section" id="modes">
        <div className="container">
          <div className="text-center">
            <span className="section-tag">See Yappyli in Action</span>
            <h2 className="section-title">Everything you love, in 30 seconds</h2>
            <p className="section-desc">Chats, stories, groups, calls, camera filters and dark mode, all in one happy place.</p>
          </div>

          <PromoVideo
            src="/videos/yappyli-promo.mp4"
            poster="/videos/yappyli-promo-poster.jpg"
            title="Yappyli app promo video"
          />
        </div>
      </section>

      {/* DOWNLOAD CTA SECTION */}
      <div className="container" id="download">
        <section className="cta-section">
          <h2>Download Yappyli Today</h2>
          <p>Start chatting, calling and playing with your friends and family on iOS and Android.</p>
          <div className="cta-buttons">
            <StoreButtons />
          </div>
        </section>
      </div>
    </div>
  );
}